module.exports = __webpack_public_path__ + "img/Phone1.0c3e35f4.svg";